import styled from 'styled-components';

export const Wrapper = styled.div.attrs(() => ({
  className: 'ClassroomDetailsWrapper',
}))`
  display: block;
  width: 95%;
  max-width: 960px;
  margin: 0 auto;
  padding: 0 20px;
  overflow-x: hidden;
`;

Wrapper.displayName = 'SettingsClassroomDetailsWrapper';
